'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createWixDataProxy = createWixDataProxy;
function createWixDataProxy(elementorySupportInstance) {
  return {
    save: function save() {
      return elementorySupportInstance.getJSON('/wix/data-web.jsw/save.ajax', arguments);
    },
    insert: function insert() {
      return elementorySupportInstance.getJSON('/wix/data-web.jsw/insert.ajax', arguments);
    },
    update: function update() {
      return elementorySupportInstance.getJSON('/wix/data-web.jsw/update.ajax', arguments);
    },
    get: function get() {
      return elementorySupportInstance.getJSON('/wix/data-web.jsw/get.ajax', arguments);
    },
    remove: function remove() {
      return elementorySupportInstance.getJSON('/wix/data-web.jsw/remove.ajax', arguments);
    },
    find: function find() {
      return elementorySupportInstance.getJSON('/wix/data-web.jsw/find.ajax', arguments);
    },
    runAggregate: function runAggregate() {
      return elementorySupportInstance.getJSON('/wix/data-web.jsw/runAggregate.ajax', arguments);
    },
    count: function count() {
      return elementorySupportInstance.getJSON('/wix/data-web.jsw/count.ajax', arguments);
    },
    bulkInsert: function bulkInsert() {
      return elementorySupportInstance.getJSON('/wix/data-web.jsw/bulkInsert.ajax', arguments);
    },
    queryReferenced: function queryReferenced() {
      return elementorySupportInstance.getJSON('/wix/data-web.jsw/queryReferenced.ajax', arguments);
    },
    insertReference: function insertReference() {
      return elementorySupportInstance.getJSON('/wix/data-web.jsw/insertReference.ajax', arguments);
    },
    insertReferences: function insertReferences() {
      return elementorySupportInstance.getJSON('/wix/data-web.jsw/insertReferences.ajax', arguments);
    },
    replaceReferences: function replaceReferences() {
      return elementorySupportInstance.getJSON('/wix/data-web.jsw/replaceReferences.ajax', arguments);
    },
    removeReference: function removeReference() {
      return elementorySupportInstance.getJSON('/wix/data-web.jsw/removeReference.ajax', arguments);
    },
    removeReferences: function removeReferences() {
      return elementorySupportInstance.getJSON('/wix/data-web.jsw/removeReferences.ajax', arguments);
    },
    isReferenced: function isReferenced() {
      return elementorySupportInstance.getJSON('/wix/data-web.jsw/isReferenced.ajax', arguments);
    },
    getSchema: function getSchema() {
      return elementorySupportInstance.getJSON('/wix/data-web.jsw/getSchema.ajax', arguments);
    }

  };
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-code-platform/lib/create-wix-data-proxy.js
// module id = 181
// module chunks = 0